import React from 'react';
import Navbar from './Navbar.jsx';

function Layout({ children }) {
  return (
    <div className="dashboard-layout">
      <Navbar />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
}

export default Layout; 